// export const IS_DEV = process.env.REACT_APP_IS_DEV && process.env.REACT_APP_IS_DEV === '1'

export const IS_PROD = true;

export const PROVIDER_ID = '269';

export const API_URL = IS_PROD
    ? 'https://www.powerlego.com/ApiGateway/'
    : 'https://dev.powerlego.com/ApiGateway/'

// IN DEV API_URL_GC
    export const API_URL_V2 = IS_PROD
    ? 'https://www.powerlego.com/ApiGateway/v2/ProdGc/'
    : 'https://dev.powerlego.com/ApiGateway/v2/ProdGc/'

export const ACC_KEY = IS_PROD
    ? '9da8dec13495277f4a6d85fec090df69'
    : '12d076fce200bbb9ca1e0c86ff5c5132'

export const GC_URL = IS_PROD ? "https://d2out2jn21l5dl.cloudfront.net/signup/api/v1/" : "https://dazn3sayspd4i.cloudfront.net/signup/api/v1/";

export const iCheckConfig = {
    ccUrl: 'https://iframe.icheckgateway.com/iFrameCC.aspx',
    baUrl: 'https://iframe.icheckgateway.com/iFrameBA.aspx',
    appId: IS_PROD ? 'JWkmIBGu9DPLMXfQcykVIfS29AltFFFz' : '123456',
    appSecret: IS_PROD ? 'xsUBCc6pBYOuSFuyGM8F22ob7F7LAmxh' : '123456',
    // appSiteId: 'NBPP',
    styles: 'payment{background:white;border-color:rgb(221,221,221);}input[type="submit"],input[type="reset"]{background:rgb(255,91,106);border-radius:30px;border:0 none;}'
}

export const dunsUtilityList = [
    { value: '007923311', label: 'AEP North', id: '4', code: 'AEPWTU' },
    { value: '007924772', label: 'AEP Central', id: '6', code: 'AEPCPL' },
    { value: '007929441', label: 'Texas New Mexico Power (TNMP)', id: '5', code: 'TNMP' },
    { value: '1039940674000', label: 'Oncor Electric Delivery', id: '2', code: 'Oncor' },
    { value: '957877905', label: 'CenterPoint Energy', id: '1', code: 'CPE' },
    // { value: '0088288574800', label: 'Nueces Coop' },
    // { value: '827438383', label: 'Entergy Gulf States Inc' },
]